import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import all translation files
import translationEN from './locales/en.json';
import translationES from './locales/es.json';

// Resources object with translations
const resources = {
  en: {
    translation: translationEN
  },
  es: {
    translation: translationES
  }
};

i18n
  // Use language detector
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Set up i18next
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false, // React already safes from XSS
    },
    
    detection: {
      // Order of language detection methods
      order: ['navigator', 'htmlTag', 'path', 'cookie', 'localStorage'],
      
      // Cache the language selection
      caches: ['localStorage', 'cookie'],
      
      // Cookie options instead of direct expiration date
      lookupCookie: 'i18next',
      cookieMinutes: 525600 // 1 year
    }
  });

export default i18n;
